<template>
    <IndumentariasComponent  :base="base" :esMovil="esMovil" :paso_activo="true" @terminado="terminar" @volver="volver" :indumentarias-seleccionadas="indumentariasSeleccionadas"/>
</template>

<script>
    import IndumentariasComponent from "@/components/frontend/bases/PasoCincoComponent";

    export default {
        props: ['base', 'indumentariasSeleccionadas', 'esMovil'],
        methods: {
            terminar(indumentariasElegidas, base) {
                base.categoria_base.indumentariasElegidas = indumentariasElegidas;
                this.$emit('terminado', base);
            },
            volver() {
                this.$emit('volver');
            }
        },
        components: {
            IndumentariasComponent
        }
    }
</script>
